import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { GetGlycerinWishlistProductPayloadFragmentFragmentDoc } from '@packages/gql/generated/shopping/GetGlycerinWishlistProductPayloadFragmentFragmentDoc';
import type { GlycerinWishListProduct } from '@packages/tracking';
import { getGlycerinArticleId } from '../getGlycerinArticleId';
import { getGlycerinAvailability } from '../getGlycerinAvailability';
import { getGlycerinOrigin } from '../getGlycerinOrigin';
import { getGlycerinPrice } from '../getGlycerinPrice';

/* GraphQL */ `
  fragment GetGlycerinWishlistProductPayloadFragment on Product {
    akl
    sku
    availability {
      ...GetGlycerinAvailabilityFragment
    }
    price {
      ...GetGlycerinPriceFragment
    }
    ...GetGlycerinArticleIdFragment
  }
`;

export type GetGlycerinWishlistProductPayloadProps = {
  data: FragmentType<typeof GetGlycerinWishlistProductPayloadFragmentFragmentDoc>;
  refSearchParam: string | null;
};

export const getGlycerinWishlistProductPayload = ({
  data,
  refSearchParam,
}: GetGlycerinWishlistProductPayloadProps): GlycerinWishListProduct => {
  const unmaskedData = getFragmentData(GetGlycerinWishlistProductPayloadFragmentFragmentDoc, data);
  const { akl, sku, price, availability } = unmaskedData;

  return {
    productId: akl,
    skuId: sku,
    ...getGlycerinArticleId(unmaskedData),
    ...getGlycerinPrice(price),
    ...getGlycerinAvailability(availability),
    ...getGlycerinOrigin(refSearchParam),
    listPosition: undefined,
  };
};
